import { BUNDLED_COURSE_BASE } from 'config/constants';

/**
 * Resolves the URL opened when launching a bundled (offline) course package.
 */
export default function getBundledCourseLaunchUrl(
  bundleReference: string,
  source?: string,
): string {
  if (source === 'fixture') {
    return `${BUNDLED_COURSE_BASE}/${bundleReference}/content/index.html`;
  }
  return bundleReference;
}
